import { Author, FifthParagraph, FourthParagraph, Img, TimeRead } from "@/componentsWP/StyledComponentsLib/StyledComponentsLib";
import dayjs from "dayjs";
import SeriesChapters from "../SeriesChapters/SeriesChapters";
import { LinkedinIcon, LinkedinShareButton } from "react-share";
import BlockMix from "../BlockMix/BlockMix";
import styles from './DefaultAsset.module.scss'
import Back from '/public/svgs/left-arrow.svg';
import get from 'lodash/get';
import { Post } from "generated-graphql";
import CopyIcon from '/public/svgs/copy.svg';
import { copyToClipboard } from "@/helpers/copy";
import Link from "next/link";
import { useEffect, useState } from "react";


function isElementInViewport(el: Element) {

  var rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}


const DefaultAsset = ({ pageBlocks, seriesParts }: {
  pageBlocks: Post;
  seriesParts: Post[] | null;
}) => {


  const [currentSectionId, setCurrentSectionId] = useState<string>('');
  const shareUrl = typeof window !== 'undefined' ? window?.location?.href : '';

  const publisherData = get(pageBlocks, 'publishers.nodes.0', {});

  const publisher = {
    name: get(publisherData, 'name', ''),
    image: get(publisherData, 'people.profilePicture.sourceUrl', ''),
    position: get(publisherData, 'people.position', ''),
    bio: get(publisherData, 'people.bio', ''),
    slug: get(publisherData, 'slug', ''),
  };

  useEffect(() => {
    if (pageBlocks.tableOfContents?.items) {
      const titles = document.querySelectorAll('.withToc h2');
      console.log('titles', titles);

      setInterval(() => {
        titles.forEach((title) => {
          const isVisible = isElementInViewport(title);
          if (isVisible) {
            console.log("title", title.getAttribute("id"), isElementInViewport(title));
            setCurrentSectionId(title.getAttribute("id") || '');
          }
        });

      }, 1000);
      //pageBlocks.tableOfContents.items = pageBlocks.tableOfContents.items.filter((item) => item.title !== "Table of Contents")
    }
  }, [pageBlocks.tableOfContents?.items])

  if (!pageBlocks) {
    return null;
  }

  const isBlog = !!pageBlocks.categories?.nodes.find((item) => item.slug === "blog")
  const seriesName = pageBlocks.categories?.nodes.find((item) => item.parent?.node.name === "Series")?.slug || ""

  const linkedInBtn = <LinkedinShareButton url={shareUrl}>
    <LinkedinIcon
      style={{
        padding: '7px',
        border: '1px solid #98A2B3',
        borderRadius: '16px',
      }}
      size={40}
      bgStyle={{ fill: '#98A2B3' }}
    />{' '}
  </LinkedinShareButton>


  const handleToCClick = (e: Event, anchor: string) => {
    e.preventDefault();
    e.stopPropagation();
    const el = document.querySelector(anchor);
    if (el) {
      const headerOffset = 65;
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }

  }
  return (
    <div style={{ marginTop: 90 }}>
      <div className="container">
        <Link
          href="/resources"
          className="d-flex align-items-center"
          style={{ marginBottom: 45, color: '#61636D', textDecoration: "none" }}
        >
          <Back />
          <FifthParagraph className="ps-2">
            See all News & Resource
          </FifthParagraph>
        </Link>
        {isBlog &&
          <TimeRead>
            <FifthParagraph>Blog</FifthParagraph>{' '}
            <FifthParagraph>
              {pageBlocks.seo?.readingTime} min read
            </FifthParagraph>
          </TimeRead>
        }

        <h1 className="mb-5 h3">{pageBlocks.title}</h1>
        <div style={{ marginBottom: '40px' }}>
          <Author>
            <div>
              <Img circleImg width={'40'} src={publisher.image} alt="" />
            </div>
            <div>
              {publisher.name &&
                <FourthParagraph TypeWight="SemiBold">
                  {publisher.name}
                </FourthParagraph>
              }
              <FourthParagraph TypeWight="Thin">
                {dayjs(pageBlocks.date).format('MMMM DD, YYYY')}
              </FourthParagraph>
            </div>
          </Author>
        </div>

        {pageBlocks.featuredImage && !pageBlocks.blogSettings?.hideFeaturedImage && (
          <img
            className="img-fluid w-100"
            src={pageBlocks.featuredImage.node.sourceUrl || ''}
            alt={pageBlocks.featuredImage.node.altText || ''}
          />
        )}
      </div>
      <div className="w-100">
        <div className={`d-flex ${pageBlocks.tableOfContents ? 'container' : styles.contentWrapper} m-auto`}>
          {seriesParts && (
            <div className={styles.sidebarWrapper}>
              <div className={styles.sidebar}>
                <div className="container">
                  <SeriesChapters series={seriesParts} seriesName={seriesName} />
                  {linkedInBtn}
                </div>
              </div>
            </div>
          )}

          <div className={`${styles.content} ${seriesParts ? styles.seriesContent : ""}`}>

            <div className="row">
              {pageBlocks.tableOfContents?.items &&
                <div className={`col-xl-2 ps-md-0 mt-5`}>

                  <div className={` ${styles.toc}`}>
                    <h3 className="xs mb-3">Contents</h3>
                    <ol>
                      {pageBlocks.tableOfContents?.items?.map((item, index) => {
                        if (!item) return null;
                        return (
                          <li key={index} className={`${styles.tocItem} ${currentSectionId === item.anchor?.replace('#', '') ? styles.tocItemActive : ''}`}>
                            <a href={`${item.anchor}`} className={styles.tocLink} onClick={(e: any) => handleToCClick(e, item.anchor || '')} >
                              <div>{index + 1}.</div>  <div>{item.title}</div>
                            </a>
                          </li>
                        );

                      })}
                    </ol>
                  </div>
                </div>
              }
              <div className={`${pageBlocks.tableOfContents?.items ? 'withToc col-xl-10' : 'col-md-12'}`}>
                <BlockMix
                  blocksData={pageBlocks?.editorBlocks}
                  acfData={pageBlocks?.builder?.sections}
                />
              </div>
            </div>
            {isBlog &&
              (<div className="container">
                <div className={styles.shareSection}>
                  <p>Share this post</p>
                  <div className="d-flex">
                    <button className="copyBtn me-3" style={{ height: "fit-content", color: "#667085" }} onClick={copyToClipboard}>
                      <CopyIcon className={styles.copyIcon} /> Copy Link
                    </button>
                    {linkedInBtn}
                  </div>
                </div>
              </div>
              )
            }

          </div>
        </div>
      </div>
    </div >
  );

}

export default DefaultAsset;